import { httpClientCMS } from '~/lib/axios'
import { TParams } from '~/types/common'
import { Post } from '~/types/types'

export const fetchListPost = async (id: string, params: TParams) => {
  return await httpClientCMS.get<API.IResponseSearch<Post>>(`/v1/posts/get-posts-by-category-id/${id}`, params).then((res) => res.data)
}


export const fetchSentContact = async (data: any) => {
  return httpClientCMS.post('/v1/contact-forms', data).then((res) => {
    return res.data
  })
}
